var map = {
	"./CaslonGraD.woff2": 711,
	"./CircularPro-Black.woff2": 714,
	"./CircularPro-BlackItalic.woff2": 717,
	"./CircularPro-Bold.woff2": 720,
	"./CircularPro-BoldItalic.woff2": 723,
	"./CircularPro-Book.woff2": 726,
	"./CircularPro-BookItalic.woff2": 729,
	"./CircularPro-Medium.woff2": 732,
	"./CircularPro-MediumItalic.woff2": 735
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1189;



//////////////////
// WEBPACK FOOTER
// ./public/fonts ^\.\/.*\.woff2$
// module id = 1189
// module chunks = 168707334958949